export enum NotificationStatus {
  notSent = 'not_sent',
  inProcess = 'inProcess',
  sent = 'sent',
}
